import React from 'react'
import { graphql } from 'gatsby'
import { Layout } from '../components/Layout'
import { Header } from 'semantic-ui-react'
import { css } from 'emotion'
import { CommentBox } from '../components/CommentBox'
import { TweetButton } from '../components/TweetButton'
import { FacebookButton } from '../components/FacebookButton'

export const styles = {}
styles.postBody = css`
  margin-bottom: 64px;
  .related-post-nav {
    display: flex;
    justify-content: space-evenly;
    & > * {
      background-color: lightgrey;
      display: block;
      padding: 16px;
      border-radius: 2px;
      :hover {
        background-color: #f0f0f0;
      }
    }
    .prev::before {
      content: '\f060';
      font-family: Icons;
      font-style: normal;
    }
    .next::after {
      content: '\f061';
      font-family: Icons;
      font-style: normal;
    }
  }
  .social-actions-container {
    display: flex;
  }
  max-width: 100vw;
  .post-content blockquote {
    position: relative;
    ::before {
      font-family: Icons;
      position: absolute;
      font-size: 24px;
      content: '\f10d';
    }
    p {
      margin: 14px;
      padding: 14px;
      padding-left: 30px;
    }
    cite {
      display: block;
      ::before {
        content: '- ';
      }
    }
    margin: 14px;
    background-color: rgba(0,0,0,0.25);
    border-left: 4px solid grey;
  }
`;

/**
 * Builds the metatags for the site based on the post.
 * @param {*} post
 */
function buildMeta({ fields, meta, excerpt }) {
  return [
    {
      property: 'og:url',
      content: 'https://esmer-games.github.io' + fields.slug,
    },
    { property: 'og:title', content: meta.title },
    { property: 'og:description', content: excerpt },
    { property: 'og:type', content: 'article' },
    {
      property: 'og:image',
      content:
        'https://esmer-games.github.io' + meta.thumbnail.data.fixed.src,
    },
    { name: 'description', content: excerpt },
    { name: 'author', content: 'Pablo Blanco Celdrán' },
    {
      name: 'copyright',
      content: 'Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International License'
    },
    { name: 'twitter:card', content: 'summary' },
    { name: 'twitter:title', content: meta.title },
    { name: 'twitter:description', content: excerpt },
    {
      name: 'twitter:image',
      content:
        'https://esmer-games.github.io' + meta.thumbnail.data.fixed.src,
    },
  ];
}

/**
 * Blog post page template.
 */
export default class BlogPost extends React.Component {
  render() {
    const {
      data: { post },
    } = this.props
    return (
      <Layout
        title={post.meta.title}
        image={post.meta.thumbnail.data.fluid}
        meta={buildMeta(post)}
      >
        <div className={styles.postBody}>
          <div className="social-actions-container">
            <TweetButton
              text={post.meta.title}
              tags={post.meta.tags}
              slug={post.fields.slug}
            />
            <FacebookButton slug={post.fields.slug} />
          </div>
          <Header as="h1">
            <Header.Content>
              {post.meta.title}
              <Header.Subheader>{post.meta.date}</Header.Subheader>
            </Header.Content>
          </Header>
          <div
            className="post-content"
            dangerouslySetInnerHTML={{ __html: post.html }}
          />
        </div>
        <CommentBox url={post.fields.slug} identifier={post.id} />
      </Layout>
    )
  }
}

export const query = graphql`
  query BlogPostQuery($slug: String!) {
    post: markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      excerpt(pruneLength: 250)
      meta: frontmatter {
        title
        tags
        date(formatString: "MMMM DD, YYYY [at] HH:MM")
        thumbnail {
          data: childImageSharp {
            fluid(maxWidth: 2048, quality: 100) {
              ...GatsbyImageSharpFluid
            }
            fixed(width: 300, height: 300, cropFocus: ATTENTION, quality: 100) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
      fields {
        slug
      }
    }
  }
`
